import tools from "utils/tools";

const Prices = ({ form, setForm }) => {
  return (
    <div className="AddInfoContainer">
      <label>قیمت</label>
      <input
        className="persianName"
        value={tools.formatPriceToStr(form?.price)}
        onChange={(input) =>
          setForm((prev) => ({
            ...prev,
            price: tools.formatStrToPrice(input.target.value),
          }))
        }
      />
      <label>قیمت با تخفیف</label>
      <input
        className="persianName"
        value={tools.formatPriceToStr(form?.discountPrice || 0)}
        onChange={(input) =>
          setForm((prev) => ({
            ...prev,
            discountPrice: tools.formatStrToPrice(input.target.value),
            // the backend prefers the percent, so a stale one would override
            // the price typed here; it is recalculated from this price on save
            discountPercent: "",
          }))
        }
      />
      <label>درصد تخفیف</label>
      <input
        className="persianName"
        value={form?.discountPercent ?? ""}
        onChange={(input) =>
          setForm((prev) => ({
            ...prev,
            discountPercent: tools.persianNumToEn(input.target.value),
            // recalculated from the percent on save
            discountPrice: 0,
          }))
        }
      />
    </div>
  );
};

export default Prices;
